export default __webpack_public_path__ + "static/YWFTUltramagnetic-5e963d958b69cd6201f3a8dc72b8a7b7.woff";